import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLock,
  faBuildings,
  faUsers,
  faAddressBook,
  faToolbox,
} from '@fortawesome/pro-solid-svg-icons';
import { Button, Card } from 'react-bootstrap-5';
import { profilePremiumSignupUrl, profileSubscriptionUrl } from 'bundles/connect/helpers/prospect_api';

type Props = {
  fromConsole: boolean;
  hasActiveConnectProduct: boolean;
};

export default function ConnectPremiumCard({ fromConsole, hasActiveConnectProduct }: Props) {
  return (
    <Card
      className="rounded border-0 z-2 connect-premium-card"
      style={fromConsole ? { width: '75%' } : {}}
    >
      <Card.Body className="p-8 gap-2">
        <div className="text-center">
          <FontAwesomeIcon className="text-danger" icon={faLock} size="2x" />
        </div>

        {hasActiveConnectProduct ? (
          <div className="text-center pt-3">
            <h6>This data is not included in your package.</h6>
            <Button
              className="w-100"
              href={profileSubscriptionUrl}
              target="_blank"
              variant="secondary"
            >
              View Your Plan Details
            </Button>
          </div>
        ) : (
          <>
            <div className="text-center pt-3 pb-4">
              <h4>Ready to unlock more data?</h4>
              <div>Looks like you're ready for an upgrade to win more business.</div>
            </div>
            <h6>Take your account to the next level with:</h6>
            <ul
              className="px-0 py-3 gap-2 d-flex flex-column"
              style={{ listStyleType: 'none' }}
            >
              <li>
                <FontAwesomeIcon className="text-danger me-2" icon={faBuildings} />
                Property data across the country
              </li>
              <li>
                <FontAwesomeIcon className="text-danger me-2" icon={faUsers} />
                Full demographic data
              </li>
              <li>
                <FontAwesomeIcon className="text-danger me-2" icon={faAddressBook} />
                Enhanced owner data lookup
              </li>
              <li>
                <FontAwesomeIcon className="text-danger me-2" icon={faToolbox} />
                Maximize your prospecting
              </li>
            </ul>
            <Button
              className="w-100"
              href={profilePremiumSignupUrl}
              target="_blank"
              variant="secondary"
            >
              Let's Go
            </Button>
          </>
        )}
      </Card.Body>
    </Card>
  );
}
